export class Label {
    private downloadLinks = <HTMLCollectionOf<HTMLAnchorElement>>document.getElementsByClassName("download-label");

    public static Init(): Label {
        return new Label();
    }

    constructor() {
        this.setDownloadLinks(null, false, (e) => this.onDownloadLinkClicked(e));
    }

    private onDownloadLinkClicked(e: MouseEvent): void {
        e.preventDefault();

        let clickedLink = <HTMLAnchorElement>e.currentTarget;

        // Disable clicks for all buttons while we are downloading, but don't change their text.
        this.setDownloadLinks(null, true, (e) => this.doNothingOnClick(e));
        // Set this specific link to 'downloading'.
        this.setDownloadLink(clickedLink, "Creating label", true, (e) => this.doNothingOnClick(e));

        let errorElement = document.getElementById("label-error");
        errorElement.classList.add("hidden");

        window.HttpRequest.Get(clickedLink.href, "blob",
            (data) => { this.onLabelReceived(clickedLink, data) },
            () => { this.onLabelError(clickedLink) });
    }

    private hideDownloadLink(selector: string): void {
        const labelElement = document.querySelector(selector);

        if (labelElement) {
            labelElement.classList.add("hidden");
        }
    }

    private onLabelReceived(clickedLink: HTMLAnchorElement, request: XMLHttpRequest): void {

        if (request && request.response) {

            // Hide the other download links now that they have a label.
            if (clickedLink.id === "DownloadRoyalMail") {
                this.hideDownloadLink("label[for=InPostTab]");
            }
            else if (clickedLink.id === "DownloadRoyalMailQR") {
                this.hideDownloadLink("label[for=InPostTab]");
            }
            else {
                this.hideDownloadLink("label[for=RoyalMailTab]");
                this.hideDownloadLink("label[for=RoyalMailQRTab]");
            }

            // Re-enable all download links (in case we downloaded one of the two RM labels).
            this.setDownloadLinks(null, false, (e) => this.onDownloadLinkClicked(e));
            // Set this specific link to 'downloaded'.
            this.setDownloadLink(clickedLink, "Downloaded, download again", false, (e) => this.onDownloadLinkClicked(e));

            let contentDisposition = request.getResponseHeader("content-disposition");
            let contentType = request.getResponseHeader("content-type");
            let matches = contentDisposition.match(/filename=(.+);/);
            let filename = "returnslabel.pdf";

            if (matches.length >= 2) {
                filename = matches[1];
            }

            // Create a new Blob object using the response data of the onload object.
            const blob = new Blob([request.response], { type: contentType });
            // Create a link element, hide it, direct it towards the blob, and then 'click' it programatically.
            let a = document.createElement("a");
            a.style.display = "none";
            document.body.appendChild(a);
            // Create a DOMString representing the blob and point the link element towards it.
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            // Programatically click the link to trigger the download.
            a.click();
            // Release the reference to the file by revoking the Object URL.
            window.URL.revokeObjectURL(url);
        }
        else { // No data returned, error on the server.
            this.onLabelError(clickedLink);
        }
    }

    private onLabelError(link: HTMLAnchorElement): void {
        let errorElement = document.getElementById("label-error");
        errorElement.classList.remove("hidden");

        // Re-enable all download links (in case we downloaded one of the two RM labels).
        this.setDownloadLinks(null, false, (e) => this.onDownloadLinkClicked(e));
        // Set this specific link to retry.
        this.setDownloadLink(link, "Retry download", false, (e) => this.onDownloadLinkClicked(e));
    }

    private doNothingOnClick(e: MouseEvent): boolean {
        e.preventDefault();
        return false;
    }

    /**
     * Sets all document download links, used on page load or to disable all buttons at once.
     * @param text
     * @param addDownloadingClass
     * @param clickCallback
     */
    private setDownloadLinks(text: string, addDownloadingClass: boolean, clickCallback): void {
        for (const link of this.downloadLinks) {
            this.setDownloadLink(link, text, addDownloadingClass, clickCallback);
        }
    }

    /**
     * Sets a single download link. Used for when a single link has been clicked, downloaded or errored.
     * @param link
     * @param text
     * @param addDownloadingClass
     * @param clickCallback
     */
    private setDownloadLink(link: HTMLAnchorElement, text: string, addDownloadingClass: boolean, clickCallback: any): void {

        if (text !== null) { // Initialising, don't set the text.
            link.innerHTML = text;
        }

        if (addDownloadingClass) {
            link.classList.add("downloading-label");
        }
        else {
            link.classList.remove("downloading-label");
        }

        link.onclick = clickCallback;
    }
}

if (document.body.dataset.pageInit == "label") {
    Label.Init();
}
